import { getLanguage } from "./i18n.js";
import {
  SITE_COPY,
  SITE_ORIGIN,
  siteStructuredData,
} from "../../shared/seo.js";

export function updatePageMetadata(pageTitle = "DayX") {
  const language = getLanguage();
  const copy = SITE_COPY[language];
  const home = document.body.dataset.presentation === "home";
  const url = SITE_ORIGIN + (home ? "/" : location.pathname);
  document.title = home ? copy.title : pageTitle;
  const set = (selector, value) => {
    const element = document.querySelector(selector);
    if (element) element.content = value;
  };
  set('meta[name="description"]', copy.description);
  set(
    'meta[name="robots"]',
    home ? "index,follow,max-image-preview:large" : "noindex,follow",
  );
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.href = url;
  set('meta[property="og:title"]', document.title);
  set('meta[property="og:description"]', copy.description);
  set('meta[property="og:locale"]', copy.locale);
  set('meta[property="og:url"]', url);
  set('meta[name="twitter:title"]', document.title);
  set('meta[name="twitter:description"]', copy.description);
  let structured = document.getElementById("dayxStructuredData");
  if (home) {
    if (!structured) {
      structured = document.createElement("script");
      structured.id = "dayxStructuredData";
      structured.type = "application/ld+json";
      document.head.append(structured);
    }
    structured.textContent = JSON.stringify(siteStructuredData(language));
  } else structured?.remove();
}
